import React from "react";
import DiscreteTextButton from "@common/LifeAtButton/Variants/DiscreteTextButton";
import { UserContextType, useUserContext } from "@contexts/UserContext";
import { firebase } from "@firebase-local/firebase";
import { RESET_PASSWORD_BUTTON_LABEL } from "@user/components/UserAccountModal/UserAccountModalConstants";

interface ResetPasswordButtonProps {
    readonly callback?: () => void;
}
export function ResetPasswordButton(props: ResetPasswordButtonProps) {
    const { user }: UserContextType = useUserContext();

    const handleResetPassword = () => {
        firebase
            .auth()
            .sendPasswordResetEmail(user.email)
            .then(() => {
                props.callback();
            });
    };

    return <DiscreteTextButton label={RESET_PASSWORD_BUTTON_LABEL} onClick={handleResetPassword} />;
}
